import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { useDispatch, useSelector } from "react-redux";
import {
  ashaDetailFilterTemplate,
  getColumns,
  reminderBodyTemplate,
} from "../../../../Shared/Utils/tableColumns";
import "./TotalAshaTableView.scss";
import { fetchTotalTopAsha, fetchTotalTopAsha_V2 } from "../../../../Store/Dashboard/DashboardActions";
import GetAreaId from "../../../../Shared/Utils/getAreaId";
import {
  getGlobalAreaType,
  getSelectedDistrictId,
  getSendTaluka,
  getTotalAsha,
  getAshaPaginationData
} from "../../../../Store/Dashboard/DashboardSelectors";
import SendReminderView from "../../../../Shared/Component/SendReminder/SendReminderView";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import ModalHeader from "../../../../Components/Header/ModalHeader";
import AshaIndividualView from "../AshaIndividualView/AshaIndividualView";
import NoRecordFound from "../../../../Shared/Component/NoRecordFound/NoRecordFound";
import CustomDataTable from "../../../../Shared/Component/CustomTable/CustomDataTable";
import { useLanguage } from "../../../ChangeLanguage/LanguageProvider";
import { useTranslation } from "react-i18next";
import { months} from "../../../../Shared/Constant/monthYear";
const TotalAshaTableView = ({activeAshaCount, inActiveAshaCount}) => {
  const { selectedLanguageId } = useLanguage();
  const roles = sessionStorage.getItem("userRole");
  const areaType = useSelector(getGlobalAreaType);
  const areaId = GetAreaId(areaType);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const ashasData = useSelector(getTotalAsha);
  const paginationData = useSelector(getAshaPaginationData);
  const districtId = useSelector(getSelectedDistrictId);
  const talukaId = useSelector(getSendTaluka);
  const dispatch = useDispatch();
 const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonthIndex = currentDate.getMonth();
  const previousMonthIndex = (currentMonthIndex + 11) % 12; 
  const previousYear = previousMonthIndex === 11 ? currentYear - 1 : currentYear; 
  const previousMonth = months[previousMonthIndex]; 
  const role = ["ASHA", "ANM"];
  const [name, setName] = useState("");
  const [statusActive, setStatusActive] = useState("");
  const [tabIndex, setTabIndex] = useState(0);
  const [filters, setFilters] = useState({});
  const [inactiveDays, setInactiveDays] = useState(0);
  const [chosenMonth, setChosenMonth] = useState(previousMonth); 
  const [chosenYr, setChosenYr] = useState(previousYear); 
  // const chosenRole = role[0];
  const [status, setStatus] = useState("");
  const [activeAshaList, setActiveAshaList] = useState([]);
  const [inactiveAshaList, setInactiveAshaList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isAshaViewVisible, setIsAshaViewVisible] = useState(false);
  const [chosenAshaId, setChosenAshaId] = useState("");
  const [chosenIndex, setChosenIndex] = useState(null);
  const { t } = useTranslation("TopAsha");
  const totcolumns = getColumns(roles, "TotalAshaTable", statusActive, t);
  function checkAdmin(role) {
    const validRoles = ["Admin", "Support Admin"];
    return validRoles.includes(role);
  }
  const result = checkAdmin(roles);
  const handleTabChange = ({ index }) => {
    setTabIndex(index);
    setSelectedItems([]);
  };

  const getPhcsFromList = (list) => {
    return list.map((el) => el.phcName);
  };
  const getListFromTabIndex = (tabIndex) => {
    return tabIndex === 0 ? activeAshaList : inactiveAshaList;
  };
  const phcFilterTemplate = (options) => {
    const list = getListFromTabIndex(tabIndex);
    let phcs = getPhcsFromList(list);
    return (
      <Dropdown
        value={options.value}
        options={Array.from(new Set(phcs))}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder={t("Search")}
        showClear
      />
    );
  };

  const handleMonthChange = (val) => {
    setChosenMonth(val);
    dispatch(fetchTotalTopAsha(areaId, selectedLanguageId));
  };

  const handleYrChange = (val) => {
    setChosenYr(val);
    dispatch(fetchTotalTopAsha(areaId, selectedLanguageId));
  };
  console.log("handleMonthChange",handleMonthChange,handleYrChange);

  const handleCellClick = (
    index,
    ashaId,
    ashaName,
    isActive,
    inactiveSince
  ) => {
    setChosenAshaId(ashaId);
    setIsAshaViewVisible(true);
    setChosenIndex(index);
    setStatus(isActive);
    setName(ashaName);
    setInactiveDays(inactiveSince);
  };

  const ashaDetailBodyTemplate = ({
    ashaid,
    ashaName,
    isactive,
    inactiveSince,
  }) => {
    return (
      <div
        className="text-blue-600 font-normal cursor-pointer"
        onClick={() =>
          handleCellClick(0, ashaid, ashaName, isactive, inactiveSince)
        }
        onKeyDown={() =>
          handleCellClick(0, ashaid, ashaName, isactive, inactiveSince)
        }
      >
        {ashaName}
      </div>
    );
  };

  const ashaActivityBodyTemplate = ({
    ashaid,
    ashaName,
    totalActivityCount,
  }) => {
    return (
      <div
        className="text-blue-600 font-normal cursor-pointer"
        onClick={() => handleCellClick(1, ashaid, ashaName)}
        onKeyDown={() => handleCellClick(1, ashaid, ashaName)}
      >
        {totalActivityCount}
      </div>
    );
  };


  const buildSelectedIds = () => {
    let idsList = [];
    selectedItems.length > 0 &&
      selectedItems.forEach((el) => {
        idsList.push(el.ashaId);
      });
    return idsList;
  };

  const closeDialog = () => {
    setIsAshaViewVisible(false);
  };
  const bodyMethods = {
    ashaName: ashaDetailBodyTemplate,
    totalActivityCount: ashaActivityBodyTemplate,
    reminderCount: reminderBodyTemplate,
  };
  const filterMethods = {
    phcName: phcFilterTemplate,
    ashaName: (options) => ashaDetailFilterTemplate(options, t),
    ashaid: (options) => ashaDetailFilterTemplate(options, t),
    joiningDate: (options) => ashaDetailFilterTemplate(options, t),
    mobileNo: (options) => ashaDetailFilterTemplate(options, t),
    stateName: (options) => ashaDetailFilterTemplate(options, t),
    districtName: (options) => ashaDetailFilterTemplate(options, t),
    talukaName: (options) => ashaDetailFilterTemplate(options, t),
    subcenterName: (options) => ashaDetailFilterTemplate(options, t),
    totalActiveCases: (options) => ashaDetailFilterTemplate(options, t),
    totalActivityCount: (options) => ashaDetailFilterTemplate(options, t),
    reminderCount: (options) => ashaDetailFilterTemplate(options, t),
    inactiveSince: (options) => ashaDetailFilterTemplate(options, t),
  };

  useEffect(() => {
    const IsActive = tabIndex === 0 ? "active" : "inactive"
    dispatch(
      fetchTotalTopAsha_V2(areaId, selectedLanguageId,IsActive,page,pageSize,filters)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    areaType,
    selectedLanguageId,
    districtId,
    talukaId,
    chosenMonth,
    chosenYr,
    tabIndex,
    page,pageSize,filters
  ]);
  useEffect(() => {
    if (ashasData) {
      const activeList = [];
      const inactiveList = [];
      ashasData.forEach((item) => {
        handleActiveStatus(item.isactive);
        if (item.isactive === "Active") {
          activeList.push(item);
        } else {
          inactiveList.push(item);
        }
      });
      setActiveAshaList(activeList);
      setInactiveAshaList(inactiveList);
    } else {
      setActiveAshaList([]);
      setInactiveAshaList([]);
    }
  }, [ashasData]);
  function handleActiveStatus(status) {
    setStatusActive(status);
  }
  const className = result ? "admin" : "cust";
  const handleTablePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };
  return (
    <div className="asha-card">
      <div className="grid align-items-center justify-content-between">
        <div className="sm:col-12 md:col-10 lg:col-10 flex flex-wrap align-items-center">
          <p className="text-xl font-light ml-2">
            {t("ttlAsha")}: {activeAshaCount + inActiveAshaCount}
          </p>
        </div>
        <div className="sm:col-12 md:col-2 lg:col-2">
          <SendReminderView
            ashaIds={buildSelectedIds()}
            isDisabled={selectedItems.length === 0}
          />
        </div>
      </div>
      <TabView activeIndex={tabIndex} onTabChange={handleTabChange}>
        <TabPanel header={`${t("active")} ${activeAshaCount}`}>
          {activeAshaList && activeAshaList.length > 0 ? (
            <div>
              <CustomDataTable
                className={className}
                columns={totcolumns}
                data={activeAshaList}
                dataKey="id"
                selectedItems={selectedItems}
                onSelectionChange={(e) => setSelectedItems(e.value)}
                filterMethodsConfig={filterMethods}
                bodyMethods={bodyMethods}
                areaId={areaId}
                page={page}
                pageSize={pageSize}
                onPageChange={handleTablePageChange}
                totalCount={paginationData?.totalCount}
                initialFilters={filters}
                onFilterChange={(newFilters) => {
                  setFilters((prevFilters) => {
                    const mergedFilters = { ...prevFilters, ...newFilters };
                    Object.keys(mergedFilters).forEach((key) => {
                      if (!mergedFilters[key]) {
                        delete mergedFilters[key];
                      }
                    });
                    return mergedFilters;
                  });
                  setPage(1);
                }}
              />
              <p>
                {paginationData?.totalCount} {t("ttlAsha")}
              </p>
            </div>
          ) : (
            <NoRecordFound />
          )}
        </TabPanel>
        <TabPanel header={`${t("inactive")} ${inActiveAshaCount}`}>
          {inactiveAshaList && inactiveAshaList.length > 0 ? (
            <div>
              <CustomDataTable
                className={className}
                columns={totcolumns}
                data={inactiveAshaList}
                dataKey="id"
                selectedItems={selectedItems}
                onSelectionChange={(e) => setSelectedItems(e.value)}
                filterMethodsConfig={filterMethods}
                bodyMethods={bodyMethods}
                areaId={areaId}
                page={page}
                pageSize={pageSize}
                onPageChange={handleTablePageChange}
                totalCount={paginationData?.totalCount}
                initialFilters={filters}
                onFilterChange={(newFilters) => {
                  setFilters((prevFilters) => {
                    const mergedFilters = { ...prevFilters, ...newFilters };
                    Object.keys(mergedFilters).forEach((key) => {
                      if (!mergedFilters[key]) {
                        delete mergedFilters[key];
                      }
                    });
                    return mergedFilters;
                  });
                  setPage(1);
                }}
              />

              <p>
                {" "}
                {paginationData?.totalCount} {t("ttlAsha")}{" "}
              </p>
            </div>
          ) : (
            <NoRecordFound />
          )}
        </TabPanel>
      </TabView>
      <Dialog
        className="cockpit-dialog"
        visible={isAshaViewVisible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => setIsAshaViewVisible(false)}
        closeOnEscape={false}
        header={
          <ModalHeader onClose={closeDialog} backText={t("BacktoTable")} />
        }
      >
        <AshaIndividualView
          ashaId={chosenAshaId}
          chosenActiveIndex={chosenIndex}
          isStatus={status}
          name={name}
          inactiveSince={inactiveDays || []}
        />
      </Dialog>
    </div>
  );
};
export default TotalAshaTableView;
